// src/utils/cdn.js


const IMG_BASE = (process.env.REACT_APP_CDN_BASE_URL || '')
    .trim()
    .replace(/\/+$/, '');

/**
 * Нормалізація ключа
 */
function normalizeKey(key) {
    return String(key)
        .trim()
        .replace(/^\/+/, '')
        .replace(/\/{2,}/g, '/');
}

/**
 * Перетворює S3 key / відносний шлях у повний CDN URL.
 *
 * Приклади:
 * "products/dog.webp"
 * "/products/dog.webp"
 * "https://cdn.com/products/dog.webp"
 */
export function toImgSrcKey(key) {
    if (!key) return '';

    const raw = String(key).trim();

    // вже абсолютний URL
    if (/^https?:\/\//i.test(raw)) return raw;

    const clean = normalizeKey(raw);

    // encode тільки сегменти, не весь URL
    const encoded = clean
        .split('/')
        .map(part => encodeURIComponent(part))
        .join('/');

    return IMG_BASE
        ? `${IMG_BASE}/${encoded}`
        : `/${encoded}`;
}


export function getCdnBase() {
    return IMG_BASE;
}
